import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat, optionalBooleanFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';
import { SubHeadding, SubPanel } from '@/components/SubPanel.tsx';

export const Urine: FC<ViewProps> = ({ result, editLink }) => {
  const sugarItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === 'urine_sugar');
  const proteinItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === 'urine_protein');
  return (
    <Panel>
      <Link to={`${editLink}#urine`}>
        <Headding icon={<Edit icon={16} />}>尿検査</Headding>
      </Link>
      <Item>
        <Grid colGap>
          <SubPanel>
            <Link to={`${editLink}#urine_sugar`}>
              <SubHeadding icon={<Edit icon={16} />}>糖</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>実施有無</Dt>
                <Dd>{optionalBooleanFormat(sugarItem?.checked ?? false, '有', '無')}</Dd>
              </Dl>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(sugarItem?.value)}</Dd>
              </Dl>
              <Dl>
                <Dt>評価</Dt>
                <Dd>{displayFormat(sugarItem?.evaluation)}</Dd>
              </Dl>
              <Dl>
                <Dt>所見有無</Dt>
                <Dd>{optionalBooleanFormat(sugarItem?.hasFinding ?? false, '有', '無')}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
          <SubPanel>
            <Link to={`${editLink}#urine_protein`}>
              <SubHeadding icon={<Edit icon={16} />}>蛋白</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>実施有無</Dt>
                <Dd>{optionalBooleanFormat(proteinItem?.checked ?? false, '有', '無')}</Dd>
              </Dl>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(proteinItem?.value)}</Dd>
              </Dl>
              <Dl>
                <Dt>評価</Dt>
                <Dd>{displayFormat(proteinItem?.evaluation)}</Dd>
              </Dl>
              <Dl>
                <Dt>所見有無</Dt>
                <Dd>{optionalBooleanFormat(proteinItem?.hasFinding ?? false, '有', '無')}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
        </Grid>
      </Item>
    </Panel>
  );
};
